/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */

import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { PrinterSettingsApi } from '../api/printersettings.api';
import { switchMap, map } from 'rxjs/operators';
import { PrinterSettingsData, PrinterSettings } from '../../../interfaces/masters/printersettings';

@Injectable()
export class PrinterSettingsService extends PrinterSettingsData {

  constructor(private api: PrinterSettingsApi) {
    super();
  }

  list(url: string): Observable<PrinterSettings[]> {
    return this.api.list(url);
  }

  getById(url:string): Observable<PrinterSettings>{
      return this.api.getById(url);
  }

  create(url: string, data:any): Observable<PrinterSettings> {
    return this.api.add(url,data);
  }

  update(url: string, data:PrinterSettings): Observable<PrinterSettings> {
    return this.api.update(url,data);
  }

  

  delete(url: string): Observable<boolean> {
    return this.api.delete(url);
  }
}
